export const SCREEN_NAME = {
    CHECKOUT: "checkout",
    PAYMENT_SUCCESS: "DO-PaymentSuccess",
    BOOKING_SUCCESS: "DO-BookingSuccess",
    PAYMENT_CART: "DO-PaymentCart",
    BOOKED_DEAL_DETAIL: "DO-BookedDealDetail",
    DINECASH_PURCHASE_SUCCESS: "DO-DC-purchase-success",
};

export const SOURCE = "do-webview";
